<template>
    <div @touchstart="$public.blur()">
        <navigation-bar Back/>
        <div class="search main">
            <!--搜尋input-->
            <search-bar :search="lastSearch" @searchWord="onKeywordEnter"/>

            <h4 class="line">最近搜尋</h4>
            <!--todo 最近搜尋放最近五筆資料-->
            <div class="history-block" v-if="keywordList.length > 0">
                <div class="li" v-for="(item, index) in keywordList" :key="index" @click="onClickKeywordRecord(index)">
                    <i class="el-icon-time"/>
                    <span>{{item}}</span>
                    <el-button type="text"
                               @click.native.stop="del(index)"
                               icon="el-icon-close"/>
                </div>
            </div>
            <p class="text-center" v-else>目前沒有搜尋紀錄</p>
            <div class="shadow-line"></div>

            <h4 class="line mt-4" v-show="false">篩選類別</h4>
            <div class="m-3" v-if="false">
                <el-checkbox v-model="checked">享樂卡特約店</el-checkbox>

                <h4 class="mt-4">消費</h4>
                <!--todo 篩選 使用套件 https://element.eleme.io/#/zh-CN/component/slider-->
                <el-slider
                        v-model="slider"
                        class="ml-2 mr-2"
                        :step="25"
                        :marks="marks"
                        :show-tooltip="false"
                        show-stops>
                </el-slider>

                <div class="text-center">
                    <el-button class="mt-5 fixed-w-210"
                               @click="$router.push({name: 'SearchList'})"
                               round>應用篩選</el-button>
                </div>
            </div>

            <h4 class="line mt-4">依縣市</h4>
            <div class="city-block">
                <el-button v-for="(item, index) in cityList" :key="index" @click="onClickCity(item)">
                    {{item.name}}
                </el-button>
            </div>
            <div class="shadow-line"></div>

            <h4 class="line mt-4" v-show="tagList.length > 0">熱門類別</h4>
            <div class="hot-block" v-show="tagList.length > 0">
                <div class="row">
                    <div class="col-6 col-md-2" v-for="(item, index) in tagList" :key="index" @click="onClickTag(item)">
                        <div class="con">
                            <span class="tag"><span>#{{item.name}}</span></span>
                            <!--<div class="pic" :style="{backgroundImage: 'url(' + item.icon + ')' }"/>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="shadow-line mt-0"></div>

            <loading
                    :active.sync=isLoading
                    :can-cancel="false"
                    :is-full-page="true">
            </loading>
            <toast/>
        </div>
    </div>
</template>

<script>
    import SearchBar from '../search/components/SearchBar';
    import * as mutationTypes from '@/store/mutationTypes';
    import Toast from "@/components/Toast.vue";


    export default {
        name: "Search",
        components: {
            SearchBar,
            Toast,
        },
        data() {
            return {
                isLoading: false,     //是否顯示載入動畫
                restaurants: [],
                input:'',//搜尋
                slider:'',//篩選
                marks: {
                    0: '$0',
                    25: '$500',
                    50: '$1,000',
                    75: '$1,500',
                    100: '$2,000',
                },
                imgUrl:'https://file.oinapp.com/oin/oin/1621963168890492.jpeg',//熱門類別假圖之後可刪
                checked: false,
                lng: 0,
                lat: 0,
                lastSearch: this.$store.state.searchRecord.lastKeyword,     //上次搜尋的關鍵字
                keywordList: [],        //關鍵字
                tagList: [],            //熱門 tag列表
                cityList: [],           //城市列表

            }
        },
        created() {

        },
        mounted() {
            let self = this;
            self.isLoading = true;
            this.getGpsLocation()
                .then( this.getStoreTypeList )
                .then( this.getCityList )
                .then( () => {
                    self.isLoading = false;
                })
                .catch( (error) => {
                    self.isLoading = false;
                    self.$store.commit(mutationTypes.SHOW_TOAST, error);
                });

            //搜尋記錄
            // this.$store.state.searchRecord.keywordList = this.getKeywordList();
            this.$store.commit('setKeywordList', this.getKeywordList());
            this.keywordList = this.$store.state.searchRecord.keywordList;

            // console.log(`keywordList: ${this.keywordList.length}` );
        },
        methods: {
            /** 從歷史關鍵字列表中刪除某個關鍵字 */
            del: function(index){
                //vuex 的關鍵字列表只是換頁暫存用，真正的記錄以 localStorage爲主
                //從歷史關鍵字列表中刪除一個關鍵字
                this.$store.commit('removeSearchRecordByIndex', index);
                //更新本頁面的搜尋記錄
                this.keywordList = this.$store.state.searchRecord.keywordList;
                //將搜尋記錄儲存到 localStorage
                this.saveKeywordList(this.keywordList);
            },

            /** 取得GPS位置 */
            getGpsLocation: function () {

                let self = this;
                return new Promise(function(resolve, reject) {
                    let onSuccess = function (position) {
                        self.lng = position.coords.longitude;
                        self.lat = position.coords.latitude;
                        //結束
                        resolve();
                    };

                    let onError = function (error) {
                        self.lng = 22.999217;
                        self.lat = 120.213831;
                        //結束
                        resolve();
                    };

                    self.$public.getGpsLocation(onSuccess, onError);
                });
            },

            /**
             * 取得店家分類列表
             * */
            getStoreTypeList: function () {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetch`StoreTypeListByClickTop10${{
                    }} ${json => {
                        if (json.status) {

                            if(self.$public.notNull(json.data)) {
                                self.tagList = json.data;
                            }
                            // console.log(`tagList: ${self.tagList.length}` );
                            //完成
                            resolve();

                        } else {
                            //失敗
                            reject('取得店家分類失敗');
                        }
                    }}`;
                });
            },
            /**
             * 取得縣市列表
             * @param lng: 緯度
             * @param lat: 經度
             * */
            getCityList: function (lng = 0, lat = 0) {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetch`GetCityListByDistancer${{
                        lng: lng,
                        lat: lat,
                    }} ${json => {

                        if(self.$public.notNull(json.data)) {
                            self.cityList = json.data;

                            //完成
                            resolve();
                        } else {
                            //失敗
                            reject('取得縣市失敗');
                        }

                    }}`;
                });
            },

            /** 以 json格式暫存 Keyword list */
            saveKeywordList: function (keywordList) {
                localStorage.setItem('keyword', JSON.stringify(keywordList));
            },

            /** 取出存在localStorage的 json格式 Keyword */
            getKeywordList: function () {
                let keywordJson = localStorage.getItem('keyword');
                if (this.$public.notNull(keywordJson)) {
                    let result = JSON.parse(keywordJson);
                    return result;
                } else {
                    return [];
                }

            },

            /** 儲存關鍵字 */
            saveKeyword: function(keyword) {
                this.keyword = keyword;
                this.$store.commit('addSearchRecord', keyword);
                this.saveKeywordList(this.$store.state.searchRecord.keywordList);
            },

            /** 關鍵字輸入 */
            onKeywordEnter: function(keyword) {
                this.saveKeyword(keyword);

                //呼叫頁
                this.$router.push({ name: `SearchList`, query: {"searchText": this.keyword} });
            },

            /** 點擊關鍵字列表 */
            onClickKeywordRecord: function(index) {
                this.onKeywordEnter(this.keywordList[index]);

                //呼叫頁
                // this.$router.push({ name: `SearchList`, query: {"searchText": this.keyword} });
            },

            /** 點擊 tag */
            onClickTag: function(tagItem) {
                this.saveKeyword(tagItem.name);
                // this.onKeywordEnter(tagItem.name);
                //呼叫頁
                this.$router.push({ name: `SearchList`, query: {"searchText": tagItem.name, "searchStoreTypeId": tagItem.id } });
            },

            /** 點擊 city */
            onClickCity: function(cityItem) {
                this.saveKeyword(cityItem.name);
                // this.onKeywordEnter(cityItem.name);
                //呼叫頁
                this.$router.push({ name: `SearchList`, query: {"searchText": cityItem.name, "searchCity": cityItem.name} });
            },
        },
    }
</script>

<style lang="less" scoped src="../../less/search.less"/>
<style lang="less" scoped>
    /deep/.app-header button.back{
        @media(min-width: 1024px){
            display: none;
        }
    }
</style>